<div class="table-container">
  @if (displayToolbar) {
    <app-list-view-toolbar
      [columns]="columns"
      [isSticky]="isToolbarSticky"
      [columnDefinition]="columnDefinition"
      [preferencesKey]="preferencesKey"
    ></app-list-view-toolbar>
  }
  <div class="scroll-x scroll-x-shadows" #scrollView>
    <table class="table table-hover">
      <thead>
        <tr>
          <th></th>
          @if (displayRowNumber) {
            <th class="counter">&nbsp;#</th>
          }
          @for (column of selectedColumns; track column) {
            @if (column.helpText) {
              <th
                [dh-list-view-header]="column.id"
                [canSort]="column.canSort"
                appTooltip="{{ column.helpText | translate }}"
                tooltipPosition="below"
                (stateChange)="onStateChange($event)"
                >
                <span class="column-caption">{{ column.caption | translate }}</span>
              </th>
            }
            @if (!column.helpText) {
              <th [dh-list-view-header]="column.id" [canSort]="column.canSort" (stateChange)="onStateChange($event)">
                <span class="column-caption">{{ column.caption | translate }}</span>
              </th>
            }
          }
          <th class="column-header"></th>
        </tr>
      </thead>
      <tbody
        class="table-striped item-list"
        cdkDropList
        [cdkDropListData]="rows"
        (cdkDropListDropped)="drop($event)"
        [cdkDropListSortPredicate]="sortPredicate"
        [cdkDropListDisabled]="!enableDragDrop"
        >
        @for (row of rows; track row; let i = $index) {
          <tr
            appListViewItem
            [class.highlight]="row.highlight"
            cdkDrag
            [cdkDragDisabled]="!enableDragDropItem(row.dataSource)"
            cdkDragLockAxis="y"
            >
            <td class="move">@if (enableDragDrop && enableDragDropItem(row.dataSource)) {
              <div cdkDragHandle></div>
            }</td>
            @if (displayRowNumber) {
              <td>
                <span>{{ i + 1 }}</span>
              </td>
            }
            @for (column of selectedColumns; track column) {
              <td (click)="onRowClicked(row, $event)">
                <dh-custom-view
                  [viewType]="column.viewType"
                  [value]="row.getValue(column)"
                  [helpText]="row.getHelpText(column)"
                  [isPhoneNumber]="column.isPhoneNumber"
                ></dh-custom-view>
              </td>
            }
            @if (!hasInlineContextMenu) {
              <td></td>
            }
            @if (hasContextMenu) {
              <app-context-menu
                [context]="row.dataSource"
                [smaller]="true"
                [menuDefinition]="contextMenuDefinition"
              ></app-context-menu>
            }
            @if (hasInlineContextMenu) {
              <td>
                <app-context-menu-inline [context]="row.dataSource" [menuDefinition]="contextMenuDefinition"></app-context-menu-inline>
              </td>
            }
            <div *cdkDragPreview matchSize="true" class="container dragdrop-placeholder">
              {{ previewText(row.dataSource) }}
            </div>
          </tr>
        }
        @if (displaySummary) {
          <tr class="list-summary">
            @if (!displayRowNumber) {
              <td class="counter" title="{{ 'COMMON.COUNT' | translate }}">{{ totalCount }}</td>
            }
            @if (displayRowNumber) {
              <td></td>
            }
            @if (displayRowNumber) {
              <td class="counter" title="{{ 'COMMON.COUNT' | translate }}">{{ totalCount }}</td>
            }
            @for (column of selectedColumns; track column) {
              <td>
                @if (column.sum) {
                  @for (summary of sumValues(column); track $index) {
                    <div>{{ summary.displayValue }}</div>
                  }
                }
              </td>
            }
            <td></td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
